<template>
  <div class="inventory consumption-recode">
    <div class="inventory-container">
      <div class="top-container">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="demo-ruleForm"
          label-width="80px"
        >
          <div class="row">
            <el-form-item label="食堂：" prop="canteen" v-if="!isCanteenAdmin">
              <el-select
                v-model="ruleForm.canteen"
                placeholder="请选择"
                class="w200"
              >
                <el-option
                  v-for="item in canteenList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物料名称：" prop="materialName">
              <el-input class="gray white w200" placeholder="请输入" v-model="ruleForm.materialName" clearable></el-input>
            </el-form-item>
            <el-form-item label="日期：" prop="date">
              <el-date-picker
                v-model="ruleForm.date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                class="white w240"
                clearable>
              </el-date-picker>
            </el-form-item>
            <el-form-item class="btn">
              <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
              <el-button class="btn-blue" type="primary" @click="search">搜索</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="container">
        <div class="table" v-if="tableData.length > 0">
          <el-table
            :data="tableData"
          >
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.lable"
              :width="item.width"
              show-overflow-tooltip
            />
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div class="nothing" v-if="tableData.length == 0">
          <div>
            <div>
              <img src="../../../../assets/nothing.png">
            </div>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import Inventory from "@/models/inventory.js"
import Canteen from "@/models/canteen.js";
import { formatTimeToDate, handleAmount } from "@/common/js/utils.js"
import { statusMixins } from "@/common/mixins/status/status.js";
export default {
  mixins: [statusMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      /* 是否是食堂管理员; 1.是， 0，不是 */
      isCanteenAdmin: 0,
      tableData: [],
      tableTitleList: [
        { prop: "materialCategoryName", lable: "分类", width: "" },
        { prop: "materialName", lable: "物料名称", width: "" },
        { prop: "num", lable: "数量", width: "" },
        { prop: "createTime", lable: "领用时间", width: "" },
      ],
      totalNum: 0,
      currentPage: 1,
      ruleForm: {
        canteen: '',
        materialName: '',
        date: ''
      },
      canteenList: [],
    }
  },

  async created() {
    config()
    await this.initCanteenList()
    this.initTableList()
  },

  methods: {
    initTableList() {
      let data = {}
      data.canteenId = this.ruleForm.canteen
      data.materialName = this.ruleForm.materialName
      data.beginDate = this.ruleForm.date ? this.ruleForm.date[0] : ''
      data.endDate = this.ruleForm.date ? this.ruleForm.date[1] : ''
      data.currentPage = this.currentPage
      Inventory.getConsumptionRecode(data).then(res => {
        if (res.success) {
          let arr = []
          this.totalNum = res.result.totalNum
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.materialCategoryName = i.categoryName
            obj.materialName = i.materialName
            obj.num = `${handleAmount(i.consumerQuantity, 2)}${this.UNIT[i.unitType]}`
            obj.unitType = i.unitType
            obj.createTime = i.consumerDate ? formatTimeToDate(i.consumerDate):''
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取食堂数据 */
    async initCanteenList() {
      let res = await Canteen.getCanteenNoPageList()
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.canteenList = arr
          this.ruleForm.canteen = arr.length > 0 ? arr[0].id : ''
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initTableList();
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initTableList();
    },

    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  }
}
</script>

<style lang='scss'>
</style>
